var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pensionskassen",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mutationen-abkl\\xE4ren",
    transform: "translate(-249.000000, -448.000000)",
    stroke: "#242F38",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Drop-Down",
    transform: "translate(233.000000, 316.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(17.000000, 133.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1011275,18.0000198 C13.1911275,17.9880198 12.3901275,17.7870198 11.6071275,17.5050198 C10.2821275,17.0280198 9.05112745,16.3630198 7.88912745,15.5730198 C4.90412745,13.5450198 2.61112745,10.9080198 1.02912745,7.6600198 C0.576127452,6.7280198 0.229127452,5.7570198 0.0671274519,4.7280198 C-0.0058725481,4.2630198 -0.0268725481,3.7960198 0.0421274519,3.3270198 C0.102127452,2.9260198 0.249127452,2.5670198 0.514127452,2.2610198 C1.10312745,1.5800198 1.72712745,0.9310198 2.41612745,0.3520198 C2.97112745,-0.1129802 3.58012745,-0.1189802 4.13512745,0.3440198 C4.52312745,0.6670198 4.88412745,1.0220198 5.24412745,1.3770198 C5.72712745,1.8550198 6.19812745,2.3460198 6.67112745,2.8330198 C6.75812745,2.9230198 6.83112745,3.0240198 6.91412745,3.1170198 C7.30312745,3.5560198 7.28112745,4.2920198 6.91812745,4.7010198 C6.59112745,5.0700198 6.25312745,5.4290198 5.91812745,5.7910198 C5.69612745,6.0310198 5.47112745,6.2700198 5.24612745,6.5060198 C5.13312745,6.6240198 5.12512745,6.7420198 5.19512745,6.8900198 C5.53812745,7.6270198 5.97312745,8.3070198 6.48912745,8.9340198 C7.41012745,10.0530198 8.43512745,11.0620198 9.59912745,11.9270198 C10.0951275,12.2950198 10.6391275,12.5740198 11.1941275,12.8370198 C11.3141275,12.8940198 11.3931275,12.8780198 11.4881275,12.7870198 C11.9871275,12.3020198 12.4931275,11.8220198 12.9971275,11.3430198 C13.0801275,11.2630198 13.1701275,11.1880198 13.2581275,11.1120198 C13.6771275,10.7430198 14.1511275,10.7420198 14.6441275,10.9200198 C14.7341275,10.9530198 14.8161275,11.0210198 14.8881275,11.0870198 C15.8911275,11.9880198 16.8531275,12.9310198 17.7421275,13.9460198 C18.0761275,14.3280198 18.0881275,15.0670198 17.7631275,15.4540198 C17.1181275,16.2260198 16.4021275,16.9270198 15.6351275,17.5770198 C15.3251275,17.8400198 14.9391275,17.9140198 14.5511275,17.9670198 C14.3791275,17.9900198 14.2051275,17.9930198 14.1011275,18.0000198 Z",
    id: "Stroke-1"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhone);
export default __webpack_public_path__ + "static/media/Icon_Phone.adb2a828b8d637ae65ce902100d6eda9.svg";
export { ForwardRef as ReactComponent };